import { hot } from "react-hot-loader";

import React from "react";

import PropTypes from "prop-types";
import Component from "./BaseComponent";

import "./styles/Menu.styl";

import CloseButton from "../assets/dynamic_SVGs/Close";
import { ThemeContainer } from "./ThemeContextProvider";

/*
	THIS IS THE SLIDE OUT MENU
	NOTE: THE CONTENTS OF THE MENU ARE DEFINED IN Note.js, THIS CLASS PROVIDES THE TEMPLATES REQUIRED TO GENERATE CONTENT
*/

class Menu extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.props.isOpen) {
      //the controls that open the panel handle their own toggling on click
      const isToggle =
        event.target.closest && event.target.closest("[data-menu-toggle]");

      if (!isToggle && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.props.onClose();
      }
    }
  }

  render() {
    const { isOpen, children, onClose, theme } = this.props;
    return (
      <ThemeContainer
        className={"Menu"}
        data-state={isOpen ? "open" : "closed"}
      >
        <div ref={this.setWrapperRef} className='menu-box'>
          {/* THE PANEL COVERS THE HEADER ON MOBILE - SO IT CARRIES ITS OWN CLOSE */}
          <div className='Close' onClick={onClose}>
            <CloseButton theme={theme} />
          </div>
          {/* CONTENT IS PASS THROUGH */}
          {children}
        </div>
      </ThemeContainer>
    );
  }
}

/*
	THIS IS THE MENU HEADER
*/
class MenuHeader extends Component {
  render() {
    //DYNAMICALLY ADD THE ONCLICK TO EACH CHILD SO THAT THE EVENT CAN BE MANAGED AT A ROOT LEVEL - INSTEAD OF ON EACH INDIVIDUAL CHILD
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        onClick: this.props.onOptionSelect
      });
    });
    return <ThemeContainer className='Header'>{children}</ThemeContainer>;
  }
}

/*
	THIS IS THE MAIN CHILD OF MENU HEADER
	NOTE: IT WILL BUBBLE UP THE ONCLICK EVENT - PASSING ANY PROPS IT HAS ASSOCIATED WITH IT
*/
class MenuHeaderOption extends Component {
  onClick() {
    this.props.onClick(this.props);
  }

  render() {
    const { selected, children } = this.props;
    return (
      <ThemeContainer
        onClick={this.onClick}
        className='Option'
        data-selected={selected}
      >
        {children}
      </ThemeContainer>
    );
  }
}

MenuHeaderOption.propTypes = {
  onClick: PropTypes.func.isRequired
};

MenuHeaderOption.defaultProps = {
  onClick: () => console.warn("onClick has not been defined")
};

/*
	THIS IS THE MENU CONTENT (SITS BELOW THE MENU HEADER)
*/
class MenuContent extends Component {
  render() {
    const { children } = this.props;
    return <ThemeContainer className='Content'>{children}</ThemeContainer>;
  }
}

//THIS MAKES IT EASIER FOR US TO ACCESS THE MENU COMPONENTS ELSEWHERE
Menu.Header = MenuHeader;
Menu.Header.Option = MenuHeaderOption;
Menu.Content = MenuContent;

export default hot(module)(Menu);

//AN ALTERNATIVE WAY TO ACCESS MENU COMPONENTS
export { Menu, MenuHeader, MenuHeaderOption, MenuContent };
